<div *ngIf="eventResult?.error; else noError">
  <div class="seatcard">
    <p class="text-danger">{{ eventResult?.message }}</p>
  </div>
</div>
<ng-template #noError>
  <div class="seatcard">
    <!-- <span>{{ eventResult.totalActualPrice | currencyConverter123 | async }}</span> -->
    <div class="logovslogo">
      <div class="vs">
        <img src="assets/images/arsenal.png" alt="" width="" height="" />
        <p>{{'eventsPage.common.vs'| i18n}}</p>
        <img src="assets/images/manchester.png" alt="" width="" height="" />
      </div>
      <div class="card-cont" *ngIf="eventResult.date; else eventDateDiv">
        <h6>{{eventResult.date.substring(0, 3)}}</h6>
        <h1>{{eventResult.date.substring(5, eventResult.date.length-1)}}</h1>
      </div>
      <ng-template #eventDateDiv>
        <div class="card-cont">
          <h1>{{ convertToDate(eventResult.eventData.date.date) | date : "MMM dd, yy" }}</h1>
        </div>
      </ng-template>
    </div>
    <div class="selectseat">
      <h1>{{ eventResult.name?eventResult.name:eventResult.event_name }}</h1>
      <div class="category-selected">
        <div *ngIf="eventResult.data; else eventCategory">
          <div *ngFor="let category of eventResult.data" class="single-category">
            <p matTooltip="{{ category.name }} {{ category.seats }}" class="truncated">{{ category.name }} {{ category.seats }}</p>
          </div>
        </div>
        <ng-template #eventCategory>
          <div class="single-category">
            <p matTooltip="{{ eventResult.category }} {{ eventResult.tickets_qty }}" class="truncated">{{ eventResult.category }} {{ eventResult.tickets_qty }}</p>
          </div>
        </ng-template>
      </div>      
      <button class="btn" *ngIf="eventResult.eventData" (click)="showDetail()">
        {{ !isViewOrder ? ('eventsPage.selectSeat.selectSeat' | i18n) : ('eventsPage.selectSeat.viewTickets' | i18n) }}
      </button>
    </div>
  </div> 
  <div *ngIf="eventResult.eventData" [ngClass]="{'open': selectSeatVisible,'evt_details_popup': true}">
    <tic-select-seat (closePopup)="hideDetail()" (selectedData)="selectedOptions($event)" [eventCount]="eventCount" [selectedCategory]="eventResult.data" [eventData]="eventResult.eventData"></tic-select-seat>
  </div>
</ng-template>